import type { Permission } from '@/api';
import { useHasPermissions } from '@/hooks/use-has-permissions';
import type { PropsWithChildren } from 'react';

type PermissionWrapperProps = {
  requiredPermissions: Permission[];
  match?: 'all' | 'some';
};

const PermissionWrapper = ({
  requiredPermissions,
  match = 'all',
  children,
}: PropsWithChildren<PermissionWrapperProps>) => {
  const hasPermission = useHasPermissions(requiredPermissions, match);

  if (!hasPermission) {
    return null;
  }
  return <>{children}</>;
};
export default PermissionWrapper;
